import type { MapTheme } from "../engine";
import { DEFAULT_MAP_THEME, mapThemeConfig } from "./mapThemes";

function mixHash(value: number): number {
  let hash = value >>> 0;
  hash = Math.imul(hash ^ (hash >>> 16), 2246822507);
  hash = Math.imul(hash ^ (hash >>> 13), 3266489909);
  return (hash ^ (hash >>> 16)) >>> 0;
}

function pickTerrainVariant({ x, y, count }: { x: number; y: number; count: number }): number {
  const hash = mixHash(Math.imul(x, 374761393) ^ Math.imul(y, 668265263));
  return hash % count;
}

export function plainColorAt({ x, y, theme }: { x: number; y: number; theme?: MapTheme }): string {
  const { plainColors } = mapThemeConfig(theme ?? DEFAULT_MAP_THEME);
  const variant = pickTerrainVariant({ x, y, count: plainColors.length });
  return plainColors[variant]!;
}
